/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';


const propTypes = {
  collapsed: React.PropTypes.bool.isRequired,
  children: React.PropTypes.node.isRequired,
};

class SidebarContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { collapsed } = nextProps;
    if (collapsed !== this.props.collapsed) {
      this.setState({ collapsed });
    }
  }

  render() {
    const { collapsed } = this.state;
    return (
      <div className={`${styles.content} ${collapsed ? styles.collapsed : ''}`}>
        {this.props.children}
      </div>
    );
  }
}

SidebarContainer.propTypes = propTypes;

export default connect(
  state => ({
    collapsed: state.sidebar.collapsed,
  }),
)(SidebarContainer);




// WEBPACK FOOTER //
// ./src/components/SidebarContainer/index.jsx